import { h } from 'preact';
import * as BaseComp from 'base/bolt/boltApp.js';
import { findInVNode } from 'utils/vnode';
import 'store/admissionsQuiz';
import 'store/customTracking';
// import s from 'base/bolt/boltApp.sss';

export default class BoltApp extends BaseComp.default {

	checkIfLoaded() {
		const base = super.checkIfLoaded();
		const activePage = this.state?.appState?.activePage;
		const admissionsQuiz = this.state?.appState?.admissionsQuiz;
		if (activePage !== 'admissionsQuiz' ) return base;
		const { scrollAnimDataReady, scrollAnimImagesReady, flashReady } = admissionsQuiz;
		return base && scrollAnimDataReady && scrollAnimImagesReady && flashReady;
	}

	renderMain(props, state) {
		const base = super.renderMain(props, state);
		const activePage = this.state?.appState?.activePage;
		if (activePage !== 'admissionsQuiz') return base;
		const header = findInVNode(base, '[key="header"]');
		if (header) {
			const admissionsQuiz = this.state?.appState?.admissionsQuiz;
			header.attributes = {
				...header.attributes,
				admissionsQuiz
			};
		}
		return base;
	}

}
